import styled from 'styled-components';
import query from 'syf-component-library/const/mediaQueries';
import { Inset } from 'syf-component-library/ui/spacing';
import { Body, H2 } from 'syf-component-library/ui/typography';
import { colors, fontSizes, fontWeights } from 'syf-component-library/defaultTheme';
export const ModalContentWrapper = styled.div `
  display: flex;
  flex-direction: column;
  height: calc(100vh - 56px);
`;
export const BodyContainer = styled.div `
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  flex: 1;

  @media ${query.greaterThanLarge} {
    max-width: 1114px;
  }
`;
export const ErrorMessageContainer = styled(Inset) `
  margin: 0;
  display: flex;
  align-content: flex-start;
  flex: 1;
`;
export const Image = styled.img `
  height: auto;
  width: 100%;
  max-width: 190px;
  margin: auto;

  @media ${query.lessThanSmall} {
    max-width: 120px;
  }
`;
export const CenteredContainer = styled.div `
  width: 100%;
  text-align: center;
`;
export const Title = styled(H2) `
  font-weight: ${fontWeights.bold};
  font-size: ${fontSizes.medium}px;
`;
export const SubTitle = styled(Body) `
  color: ${colors.black};
  font-weight: 500;
  font-size: ${fontSizes.root}px;
`;
export const NoteContainer = styled(Inset) `
  width: 90%;
  margin-inline: auto;
`;
